import { FIELD_GROUPS } from "@/lib/setup/fields";
import type { ConceptScope } from "@/types/concept";

/** Search terms are stored as one comma-joined string; chips work on the list. */
export const splitTerms = (s: string) => s.split(",").map((t) => t.trim()).filter(Boolean);

const LEAN = { classic: "classics", balanced: "balanced", recent: "recent work" } as const;

/** "Any year · any field · balanced" — the concept-so-far panel's scope line. */
export function scopeSummary(s: ConceptScope | null | undefined): string {
  const years = s?.year_min != null || s?.year_max != null ? `${s?.year_min ?? "…"}–${s?.year_max ?? "now"}` : "Any year";
  const field = s?.field ? FIELD_GROUPS[s.field].label : "any field";
  return `${years} · ${field} · ${LEAN[s?.recency ?? "balanced"]}`;
}
